import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { PerEmpty } from '../../components/custom_components/Empty'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { useCultivatingTalentsIsEnabled } from '../../graphql/talents-season/useRankingIsEnabled'
import { CultivatingTalentsView } from '../companySettings/cultivatingTalents/CultivatingTalentsView'
import { useCultivatingTalentsStore } from './CultivatingTalentsStore'

export const CultivatingTalentsPageContent: FC = () => {
  const { t } = useTranslation()
  const [selected] = useCultivatingTalentsStore((state) => [state.selected], shallow)
  const { companyId, country } = selected
  const {
    data: cultivatingTalentsData,
    error: cultivatingTalentsError,
    loading: cultivatingTalentsLoading,
  } = useCultivatingTalentsIsEnabled(companyId, country)

  if (cultivatingTalentsLoading || cultivatingTalentsError || !cultivatingTalentsData) {
    return (
      <LoadingAndErrors
        isLoading={cultivatingTalentsLoading}
        hasNoData={!cultivatingTalentsData}
        error={cultivatingTalentsError}
        showSpinner
      />
    )
  } else {
    return cultivatingTalentsData.isCultivatingTalentsEnabledForCompanyAndCountry ? (
      <CultivatingTalentsView
        companyId={companyId}
        country={country}
        isHRSettings={false}
        isAllCompaniesSettings={false}
        isYourCompanyView={false}
      />
    ) : (
      <BackgroundBox color="white75" r>
        <PerEmpty iconSize="m" icon="empty_stroke" heading={t('companySettingsView.rankingTab.cultivatingTalentsDisabled')} />
      </BackgroundBox>
    )
  }
}
